module.exports = __webpack_public_path__ + "img/hojas-slider-02.39de72c6.svg";